<template>
  <div class="footer" id="footer">
    <section class="top myMain">
      <!-- 联系方式 -->
      <div class="contact hidden-sm-and-down">
        <ul>
          <li>
            <div class="title">
              <p>友情链接</p>
              <i class="line"></i>
            </div>
            <div class="info">
              <p @click="jump(1)" style="cursor:hand;">中国田径协会</p>
              <p @click="jump(2)" style="cursor:hand;">世界田联</p>
              <p @click="jump(3)" style="cursor:hand;">国家体育总局</p>
              <p @click="jump(4)" style="cursor:hand;">中田体育</p>
              
            </div>
          </li>
          <li>
            <div class="title">
              <p>关于我们</p>
              <i class="line"></i>
            </div>
            <p>电话：{{tel}}</p>
            <p>邮编：100020</p>
            <p>地址：{{address}}</p>
            <p>业务邮箱：{{mail}}</p>
            <p>廉政邮箱：zt@chinaath.com</p>
          </li>
          <li>
            <div class="codeBox">
              <div>
                <img src="@/assets/image/qrcode/offical.jpg" alt="" />
                <p>扫描关注官方公众号</p>
              </div>
              <div>
                <img src="@/assets/image/qrcode/wechat.jpg" alt="" />
                <p>扫描添加官方微信号</p>
              </div>
            </div>
          </li>
          <li>
            <div class="contactMe">
              <img src="@/assets/image//home/mobile/phone.png" alt="" />
              <h3>{{tel}}</h3>
              <p>业务咨询及投诉电话</p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <!-- 版权 -->
    <div class="copyright">
      <ul>
        <li>Copyright © 2022 中田认证服务(北京)有限公司 版权所有</li>
        <li><a class="beian-link" href="http://beian.miit.gov.cn" target="_blank">京ICP备20024804号-1</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { info } from "../../api/aboutUs";
export default {
  data() {
    return {
      address:"北京市朝阳区博大路3号自主城1号楼",
      tel:"010-8716 1759",
      mail:"renzheng@chinaath.com",
    };
  },
  mounted(){
    this.getInfo();
  },
  

  methods: {
    getInfo(){
      info(["aboutBgImg", "address", "mail", "tel","companyImg"]).then((res) => {
        if (res.errCode == 0) {
          this.address = res.data.address;
          this.mail = res.data.mail;
          this.tel = res.data.tel;         
        } else {

        }
      });
    },
    jump(type) {
      let url;
      switch (type) {
        case 1:
          url = "http://www.athletics.org.cn/";
          break;
        case 2:
          url = "https://www.worldathletics.org/";
          break;
        case 3:
          url = "https://www.sport.gov.cn/";
          break;
        case 4:
           url = "https://www.chinaath.com/";
           break;   
        default:
          break;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #111111;
  opacity: 0.9;
  padding-top: 44px;
  font-size: 14px;
  .top {
    .contact {
      ul {
        display: flex;
        justify-content: space-between;
        li {
          text-align: left;
          p {
            font-size: 14px;
            color: #8b8b8b;
            line-height: 14px;
            margin-bottom: 28px;
          }
          .title {
            p {
              font-size: 18px;
              font-weight: 600;
              color: #ffffff;
              line-height: 18px;
              margin: 0;
            }
            .line {
              display: inline-block;
              width: 30px;
              height: 2px;
              background: #cc3b3f;
              margin: 6px 0 30px 0;
            }
          }
          .codeBox {
            display: flex;
            div {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-right: 18px;
              img {
                width: 100px;
                height: 100px;
               
                margin-bottom: 18px;
              }
            }
          }
          .contactMe {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
              width: 44px;
              height: 44px;
            }
            h3 {
              font-size: 27px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: #ffffff;
              line-height: 36px;
              margin: 28px 0 12px 0;
            }
            p {
              font-size: 14px;
              font-weight: 400;
              color: #8b8b8b;
              line-height: 14px;
            }
          }
        }
      }
    }
  }
  .copyright {
    display: flex;
    align-items: center;
    padding: 26px 0;
    ul {
      width: 100%;
      display: flex;
      justify-content: center;
      li {
        font-size: 14px;
        font-weight: 400;
        color: #8b8b8b;
        line-height: 20px;
        &:nth-child(1) {
          margin-right: 72px;
        }
      }
    }
  }
  .beian-link{
    color: inherit;
    text-decoration: none;
  }
}
//移动端

@media screen and (max-width: 960px) {
  #footer {
    padding: 0.24rem 0;
    width: 100%;
    .copyright {
      padding: 0;
      ul {
        display: flex;
        flex-direction: column;
        li {
          font-size: 0.14rem;
          font-weight: 400;
          color: #8b8b8b;
          line-height: 0.2rem;
          margin-right: 0;
          opacity: 0.6;
          display: flex;
          justify-content: center;
          &:nth-child(1) {
            margin-bottom: 0.08rem;
          }
        }
      }
    }
  }
}
</style>